import Base from './base'

export default class Teams extends Base {
  list(params: object = {}) {
    return this.apiClient.get('/teams', params)
  }

  create(data: object) {
    return this.apiClient.post('/teams', data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`/teams/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/teams/${id}`)
  }

  setUserTeams(userId: string, teamIds: string[]) {
    return this.apiClient.put(`/users/${userId}/teams`, { teamIds })
  }
}
